// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_lJ0YY","card":"index_card_3exIt","detail":"index_detail_1pSUC"};